import { makeObservable, observable } from 'mobx';
import { AssetsModel } from 'src/models/assets/assets-model';
import { storeFactory } from 'src/utils/store';
import { CalendarModel } from '../../models/calendar/calendar-model';

export class CalendarStore {
  @observable activityStore = new AssetsModel();
  @observable calendar = new CalendarModel();


  constructor() {
    makeObservable(this);
  }

}

export const { store: calendarStore, storeCtx: calendarStoreCtx } =
  storeFactory(CalendarStore, 'calendar');
